export const chartColumns = () => {
  return [
    {
      field: 'collateralNo', //
      title: '质押明细行',
      width: '150',
      editRender: { name: 'select' },
    },
    {
      field: 'goodsType', //
      title: '货物类型',
      width: '150',
      editRender: { name: 'goodsType' },
    },
    {
      field: 'goodsCategory', //
      title: '货物品类',
      width: '140',
      editRender: { name: 'goodsCategory' },
    },
    {
      field: 'goodsModel',
      title: '规格型号',
      width: '140',
      editRender: { name: 'goodsModel' },
    },
    {
      field: 'checkQuantity',
      title: '抽检重量/数量',
      width: '140',
      editRender: { name: 'quantity' },
    },
    {
      field: 'checkDate', //
      title: '抽检时间',
      width: '140',
      editRender: { name: 'date' },
    },
    {
      field: 'remark',
      title: '备注',
      width: '140',
      editRender: { name: 'input' },
    },
  ];
};
